import './app.scss';
import NavBar from './components/navbar/NavBar';
import { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';  

import Images from './components/image/Images';
import Blog from './components/blog/Blog';
import About from './components/about/About';
import Contact from './components/contact/Contact';
import Press from './components/press/Press';
import Partners from './components/partners/Partners';
import FovCalculator from './components/tools/FovCalculator';
import Post from './components/blog/Post';
import Image from './components/image/Image';
import NotFound from './components/notfound/NotFound';
import { AuthProvider } from './components/admin/AuthContext';
import ProtectedRoute from './components/admin/ProtectedRoute';

import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';

import 'bootstrap/dist/css/bootstrap.min.css';

const Login = lazy(() => import('./components/admin/login/Login'));
const Dashboard = lazy(() => import('./components/admin/dashboard/Dashboard'));
const PostsAdmin = lazy(() => import('./components/admin/posts/PostsAdmin'));
const FeaturesAdmin = lazy(() => import('./components/admin/features/FeaturesAdmin'));
const AddPost = lazy(() => import('./components/admin/addpost/AddPost'));
const BlogPostPreview = lazy(() => import('./components/admin/addpost/BlogPostPreview'));
const AddFeature = lazy(() => import('./components/admin/addfeature/AddFeature'));
const HomepageFeature = lazy(() => import('./components/admin/homepagefeature/HomepageFeature'));

const AdminRoute = ({ children }) => (
	<Suspense fallback={<div className='admin-status-message'>Loading admin...</div>}>
		{children}
	</Suspense>
);

function App() {
	useEffect(() => {
    	if ('scrollRestoration' in window.history) {
        	window.history.scrollRestoration = 'manual';
    	}
	}, []);

	return (
		<AuthProvider>
			<Router>
				<NavBar />

				<ScrollToTop />
				<ScrollToTopButton />

				<main>
				<Routes>
					<Route path='/' element={<Images />} />
					<Route path='/images' element={<Images />} />
					
					<Route path='/blog' element={<Blog />} />
					<Route path='/press' element={<Press />} />
					<Route path='/partners' element={<Partners />} />
					<Route path='/tools/fov-calculator' element={<FovCalculator />} />
					<Route path='/about' element={<About />} />
					<Route path='/contact' element={<Contact />} />

					<Route path='/blog/:blogURL' element={<Post />} />

					<Route path='/images/:imageId' element={<Image />} />

					<Route
						path='/admin/login'
						element={(
							<AdminRoute>
								<Login />
							</AdminRoute>
						)}
					/>
					<Route
						path='/admin/dashboard'
						element={(
							<AdminRoute>
								<ProtectedRoute>
									<Dashboard />
								</ProtectedRoute>
							</AdminRoute>
						)}
					/>
					<Route
						path='/admin/add-blog-post'
						element={(
							<AdminRoute>
								<ProtectedRoute>
									<AddPost />
								</ProtectedRoute>
							</AdminRoute>
						)}
					/>
					<Route
						path='/admin/posts'
						element={(
							<AdminRoute>
								<ProtectedRoute>
									<PostsAdmin />
								</ProtectedRoute>
							</AdminRoute>
						)}
					/>
					<Route
						path='/admin/posts/:postId/edit'
						element={(
							<AdminRoute>
								<ProtectedRoute>
									<AddPost />
								</ProtectedRoute>
							</AdminRoute>
						)}
					/>
					<Route
						path='/admin/blog-preview'
						element={(
							<AdminRoute>
								<ProtectedRoute>
									<BlogPostPreview />
								</ProtectedRoute>
							</AdminRoute>
						)}
					/>
					<Route
						path='/admin/add-feature-link'
						element={(
							<AdminRoute>
								<ProtectedRoute>
									<AddFeature />
								</ProtectedRoute>
							</AdminRoute>
						)}
					/>
					<Route
						path='/admin/features'
						element={(
							<AdminRoute>
								<ProtectedRoute>
									<FeaturesAdmin />
								</ProtectedRoute>
							</AdminRoute>
						)}
					/>
					<Route
						path='/admin/features/:featureId/edit'
						element={(
							<AdminRoute>
								<ProtectedRoute>
									<AddFeature />
								</ProtectedRoute>
							</AdminRoute>
						)}
					/>
					<Route
						path='/admin/homepage-feature'
						element={(
							<AdminRoute>
								<ProtectedRoute>
									<HomepageFeature />
								</ProtectedRoute>
							</AdminRoute>
						)}
					/>

					<Route path='*' element={<NotFound />} />
				</Routes>
				</main>
			</Router>
		</AuthProvider>
	);
}

export default App;
